import { request } from "../utils/request.js"

export const organization_findUnfrozenList = (args) => request({
    url: 'organization/findUnfrozenList',
    method: 'POST',
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/organization.js